import styled from 'styled-components'
import { Holding } from 'components/StateProvider'

import { PieChart } from 'react-minimal-pie-chart'
import AspectRatio from './Util/AspectRatio'
import MarginPadding from 'components/Util/MarginPadding'

interface Props {
  data: Holding
}

const Tile = ({ data } : Props) => {

  const isCash = data.Name === 'Cash'

  return (
    <S_Tile>
      <AspectRatio ratio={16/10}>
      <S_Left>
        <S_Name>{ data.Name }</S_Name>  
        <S_Symbol>{ data.Symbol }</S_Symbol>
        <S_Price>{ data.Price }</S_Price>

        {
          !isCash
            ? <>
                <S_Gain positive={data?.Gain?.charAt(0) !== '-'}>
                  <S_DollarGain>{data.Gain}&nbsp;</S_DollarGain>
                  <S_PercentageGain>{`(${data['% Gain']})`}</S_PercentageGain>
                </S_Gain>

                <S_Shares>{ data['Total Shares'] } shares ({ data['Market Value']})</S_Shares>
              </>
            : <S_Shares>{ data['Market Value']}</S_Shares>
        }
      </S_Left>

      
      
      <S_Right>
        <S_Sector>{ data.Sector} </S_Sector>

        {
          !isCash
            ? <S_Flex>
                <S_PortfolioWeight>
                  <MarginPadding
                    mx={.5}
                  />

                  <S_PieChart
                    animate={true}
                    startAngle={270}
                    data={[
                      { value: Number(data['% Sector']?.slice(0,-1)), color: 'var(--Primary)' },
                      { value: 100 - Number(data['% Sector']?.slice(0,-1)), color: 'var(--Font_Color_Transparent)' },
                    ]}
                  />

                  <S_Weight primary={true}>Sector: {Number(data['% Sector']?.slice(0,-1)).toFixed(1)}%</S_Weight>
                </S_PortfolioWeight>
              </S_Flex>
            : null
        }

        <S_Flex>
          <S_PieChart
            animate={true}
            startAngle={270}
            data={[
              { value: 100 - Number(data['% Portfolio']?.slice(0,-1)), color: 'var(--Font_Color_Transparent)' },
              { value: Number(data['% Portfolio']?.slice(0,-1)), color: 'var(--Primary)' },
            ]}
          />
          <S_Weight >Portfolio: {Number(data['% Portfolio']?.slice(0,-1)).toFixed(1)}%</S_Weight>

        </S_Flex>
      </S_Right>
      </AspectRatio>
    </S_Tile>
  )
}

export default Tile

const S_Tile = styled.div`
  width: 100%;
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: var(--Tile_Radius);
  max-width: 370px;
  padding: 1rem;
  cursor: pointer;
  border-radius: .5rem;
  box-shadow: var(--Outline);
  * {
    line-height: 1.5em;
  }
`

const S_Left = styled.div`
  width: 60%;
  height: 100%;
  
  border-right: 1px solid #ddd;
  padding-right: .5rem;
`

const S_Name = styled.div`
  width: 100%;
  font-size: 18px;
  font-weight: 600;
`

const S_Price = styled.div`
  font-size: 18px;
  font-family: monospace;
`

const S_Gain = styled.div`
  display: flex;
  color: ${props => props.positive ? 'var(--Font_Color_Success)' : 'var(--Font_Color_Error)'};
  font-family: monospace;
`

const S_DollarGain = styled.div`
  
`

const S_PercentageGain = styled.div`
  
`

const S_Shares = styled.div`
  font-family: monospace;
  
`


const S_Flex = styled.div`
  width: 100%;
  flex-wrap: wrap;
  display: flex;
  justify-content: center;
  margin-top: .5rem;
`

const S_Right = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 40%;
  height: 100%;
  padding-left: .5rem;
`

const S_Symbol = styled.div`
  text-transform: uppercase;
  font-size: 12px;
  padding-bottom: .5rem;
`

const S_Sector = styled.div`
  text-align: center;
  text-transform: uppercase;
  font-size: 12px;
  margin: .125rem 0;
`

const S_PieChart = styled(PieChart)`
  height: 28px;
`

const S_PortfolioWeight = styled.div`
  width: 100%;
  text-align: center;
  font-size: 12px;
`

const S_Weight = styled.div`
  font-family: monospace;
  color: ${props => props.primary ? 'var(--Primary)' : 'var(--Font_Color)'};
  text-align: center;
`
